import type { ReactElement } from 'react';
import { Box } from '@ardoq/layout';
import { Text } from '@ardoq/typography';

type CaptureResultsSummaryProps = {
  currentPageNumber: number;
  perPage: number;
  totalResults: number;
  resultTypeLabel?: string;
};

export const CaptureResultsSummary = ({
  currentPageNumber,
  perPage,
  totalResults,
  resultTypeLabel,
}: CaptureResultsSummaryProps): ReactElement => {
  const from = perPage * (currentPageNumber - 1) + 1;
  const to = Math.min(perPage * currentPageNumber, totalResults);
  return (
    <Box marginTop="medium">
      <Text variant="text2" align="center">
        Showing{' '}
        <strong>
          {from}-{to}
        </strong>{' '}
        of <strong>{totalResults}</strong>{' '}
        {resultTypeLabel ? `${resultTypeLabel} ` : ''}
        results
      </Text>
    </Box>
  );
};
